import React, { useEffect, useState, useMemo } from "react";
import { api } from "@/lib/api";
import { fmtEUR } from "@/lib/format";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { Trash2, Package } from "lucide-react";

export const FASES = ["Cold", "Terugbellen", "Sample opsturen", "Sample opgestuurd", "Onderhandeling", "Deal!", "Afgevallen"];

export function ProductLijst({ value, onChange }) {
  // value = [{product_id, aantal}]
  const [producten, setProducten] = useState([]);
  useEffect(() => { api.get("/producten").then(r => setProducten(r.data)); }, []);
  const prodMap = useMemo(() => Object.fromEntries(producten.map(p => [p.id, p])), [producten]);

  const add = (pid) => {
    if (!pid || value.find(v => v.product_id === pid)) return;
    onChange([...value, { product_id: pid, aantal: 1 }]);
  };
  const remove = (pid) => onChange(value.filter(v => v.product_id !== pid));
  const setAantal = (pid, n) => onChange(value.map(v => v.product_id === pid ? { ...v, aantal: n } : v));

  const totaal = value.reduce((s, v) => {
    const p = prodMap[v.product_id];
    return s + (Number(v.aantal) || 0) * (Number(p?.verkoopprijs) || 0);
  }, 0);

  return (
    <div className="space-y-2">
      <div className="flex items-center justify-between">
        <Label>Artikelen in de aanbieding</Label>
        <span className="text-sm text-muted-foreground">Totaal per kans: <strong className="text-foreground">{fmtEUR(totaal)}</strong></span>
      </div>
      <Select value="" onValueChange={add}>
        <SelectTrigger data-testid="camp-product-picker"><SelectValue placeholder="+ Voeg artikel toe…" /></SelectTrigger>
        <SelectContent className="max-h-80">
          {producten.filter(p => !value.find(v => v.product_id === p.id)).map(p => (
            <SelectItem key={p.id} value={p.id}>
              {p.sku} — {p.naam} ({fmtEUR(p.verkoopprijs)})
            </SelectItem>
          ))}
        </SelectContent>
      </Select>
      {value.length === 0 ? (
        <div className="text-xs text-muted-foreground italic border border-dashed border-border rounded-md p-3">
          Geen artikelen geselecteerd — kansen krijgen alleen het bedrag (zie hieronder), zonder regels.
        </div>
      ) : (
        <div className="border border-border rounded-md divide-y divide-border">
          {value.map(v => {
            const p = prodMap[v.product_id];
            if (!p) return null;
            return (
              <div key={v.product_id} className="p-3 flex items-center gap-3" data-testid={`camp-prod-${v.product_id}`}>
                <Package className="h-4 w-4 text-muted-foreground" />
                <div className="flex-1 min-w-0">
                  <div className="text-sm font-medium truncate">{p.naam}</div>
                  <div className="text-xs text-muted-foreground">{p.sku} · {fmtEUR(p.verkoopprijs)} / stuk</div>
                </div>
                <Input type="number" min="1" step="1" className="w-20"
                  value={v.aantal} onChange={(e)=>setAantal(v.product_id, parseFloat(e.target.value) || 0)} />
                <div className="w-24 text-right font-medium">{fmtEUR((Number(v.aantal)||0) * (Number(p.verkoopprijs)||0))}</div>
                <Button size="icon" variant="ghost" className="text-destructive" onClick={()=>remove(v.product_id)}>
                  <Trash2 className="h-4 w-4" />
                </Button>
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
}

